import { HttpService } from "@karma-games/angular-devkit/src/lib/services/http";
import { Store } from "@karma-games/angular-devkit/src/lib/extended-store";
import { UserRepository } from "@karma-games/angular-devkit/src/lib/modules/user";
import { Inject, Injectable, Injector } from "@angular/core";
import { debounceTime, takeUntil } from "rxjs/operators";
import { ICommunication, SocketService } from "@karma-games/angular-devkit/src/lib/services/communication";
import { Observable, Subject } from "rxjs";
import { IClientUserRepository } from "./interfaces";
import { DOCUMENT } from "@angular/common";

@Injectable()
export class ClientUserRepository extends UserRepository implements IClientUserRepository {
    protected gameNsp: ICommunication | undefined = undefined;
    protected destroy$: Subject<void> = new Subject();
    protected balanceUpdate$: Subject<number> = new Subject();
    private socket: SocketService | undefined = undefined;

    constructor(store: Store,
                http: HttpService,
                private injector: Injector,
                @Inject(DOCUMENT) document: Document) {
        super(store, http, document);
    }

    attachBalanceListener(injector?: Injector): void {
        const currentInjector = injector ?? this.injector;
        this.socket = currentInjector.get(SocketService);
        this.gameNsp = this.socket.connectToNamespace("/game");
        (<ICommunication>this.gameNsp).on<any>("balanceUpdate")
            .pipe(debounceTime(1500), takeUntil(this.destroy$))
            .subscribe((data: { payload: { amount: number } }) => {
                this.balanceUpdate$.next(data.payload.amount);
            });
    }

    subscribeBalanceUpdate(): Observable<number> {
        return this.balanceUpdate$.asObservable();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
    }
}
